import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Linkedin, Facebook, ArrowRight } from 'lucide-react';

import FOOTER_LOGO_URL from '../assets/images/Dgitaal_logo.png';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-white border-t border-gray-100" data-testid="footer">
      {/* Main footer */}
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12">

          {/* Brand column */}
          <div className="lg:col-span-2 space-y-5">
            <Link to="/" data-testid="footer-logo">
              <img src={FOOTER_LOGO_URL} alt="Dgitaal" className="h-10 w-auto" />
            </Link>
            <p className="text-[#646b82] text-sm leading-7 max-w-sm">
              Uw betrouwbare IT-partner voor innovatieve oplossingen. Van cloud
              tot cybersecurity — wij verbinden optimaal.
            </p>
            <div className="flex items-center gap-3">
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-full border border-gray-200 flex items-center justify-center text-[#646b82] hover:bg-[#3d56a6] hover:border-[#3d56a6] hover:text-white transition-all"
                data-testid="social-linkedin"
              >
                <Linkedin className="w-4 h-4" />
              </a>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-full border border-gray-200 flex items-center justify-center text-[#646b82] hover:bg-[#3d56a6] hover:border-[#3d56a6] hover:text-white transition-all"
                data-testid="social-facebook"
              >
                <Facebook className="w-4 h-4" />
              </a>
            </div>
          </div>

          {/* Company links */}
          <div>
            <h4 className="text-[#16224b] font-bold text-sm uppercase tracking-wider mb-5">Bedrijf</h4>
            <ul className="space-y-3">
              {[
                { label: 'Bedrijfsoplossingen', to: '/bedrijfsoplossingen' },
                { label: 'Referenties',          to: '/referenties' },
                { label: 'Jobs',                 to: '/jobs' },
                { label: 'Partners',             to: '/partners' },
                { label: 'Nieuws',               to: '/nieuws' },
              ].map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="text-[#646b82] text-sm hover:text-[#3d56a6] transition-colors"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Diensten */}
          <div>
            <h4 className="text-[#16224b] font-bold text-sm uppercase tracking-wider mb-5">Diensten</h4>
            <ul className="space-y-3">
              {[
                { label: 'Microsoft 365',    to: '/diensten/microsoft365' },
                { label: 'Cybersecurity',    to: '/diensten/cybersecurity' },
                { label: 'Managed Services', to: '/diensten/managed-services' },
                { label: 'Cloud & Azure',    to: '/cloud' },
                { label: 'Backup & Recovery',to: '/diensten/backups' },
                { label: 'Monitoring',       to: '/diensten/monitoring' },
              ].map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="text-[#646b82] text-sm hover:text-[#3d56a6] transition-colors"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-[#16224b] font-bold text-sm uppercase tracking-wider mb-5">Contact</h4>
            <ul className="space-y-4 text-sm text-[#646b82]">
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0 text-[#f2a100]" />
                <span>Gaston Crommenlaan 8<br/>9050 Gent, België</span>
              </li>
              <li>
                <a href="tel:+32470416675" className="flex items-center gap-3 hover:text-[#3d56a6] transition-colors" data-testid="footer-phone">
                  <Phone className="w-4 h-4 flex-shrink-0 text-[#f2a100]" />
                  +32 470 41 66 75
                </a>
              </li>
              <li>
                <a href="mailto:hello@dgitaal.be" className="flex items-center gap-3 hover:text-[#3d56a6] transition-colors" data-testid="footer-email">
                  <Mail className="w-4 h-4 flex-shrink-0 text-[#f2a100]" />
                  hello@dgitaal.be
                </a>
              </li>
            </ul>

            <Link
              to="/contact"
              className="mt-6 inline-flex items-center gap-2 text-sm font-bold text-[#3d56a6] hover:gap-3 transition-all"
              data-testid="footer-contact-link"
            >
              Neem contact op <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-gray-100">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-5 flex flex-col md:flex-row items-center justify-between gap-3 text-sm text-[#646b82]">
          <p>© {year} Dgitaal. Alle rechten voorbehouden.</p>
          <div className="flex items-center gap-6">
            <Link to="/privacy"      className="hover:text-[#3d56a6] transition-colors" data-testid="footer-privacy">Privacybeleid</Link>
            <Link to="/voorwaarden"  className="hover:text-[#3d56a6] transition-colors" data-testid="footer-terms">Algemene Voorwaarden</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
